import { useState } from "react";
import { Card } from 'react-bootstrap';


function Puzzle(){
    const imagePairs  = [
        { id: 1, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i1.jpg", pairId: 1 },
        { id: 2, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i2.jpg", pairId: 2 },
        { id: 3, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i3.jpg", pairId: 3 },
        { id: 4, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i4.jpg", pairId: 4 },
        { id: 5, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i3.jpg", pairId: 3 },
        { id: 6, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i2.jpg", pairId: 2 },
        { id: 7, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i4.jpg", pairId: 4 },
        { id: 8, src: "http://localhost:8080/teszt_wp/wp-content/uploads/puzzle/img/i1.jpg", pairId: 1 },
      ];


      // Állapotok
    const [selectedCards, setSelectedCards] = useState([]); // Kijelölt kártyák
    const [matchedPairs, setMatchedPairs] = useState([]);  // Megtalált párok
    const [isDisabled, setIsDisabled] = useState(false);  // Kártyák letiltása (párok ellenőrzése közben)
    
    const [isOpen, setIsOpen] = useState(true);
    
    // Kártya kattintás kezelése
    const handleCardClick = (id, pairId) => {
      if (isDisabled || selectedCards.length === 2 || matchedPairs.includes(pairId)) return;

      const newSelectedCards = [...selectedCards, { id, pairId }];
      setSelectedCards(newSelectedCards);

      // Ha két kártya van kijelölve, ellenőrizd, hogy párt alkotnak-e
      if (newSelectedCards.length === 2) {
        setIsDisabled(true);
        setTimeout(() => {
          checkForMatch(newSelectedCards);
        }, 1000);
      }
    };
    // Párok ellenőrzése
    const checkForMatch = (cards) => {
      const [firstCard, secondCard] = cards;

      if (firstCard.pairId === secondCard.pairId) {
        setMatchedPairs([...matchedPairs, firstCard.pairId]);
      }

      setSelectedCards([]);
      setIsDisabled(false);
    };

    // Kártya stílusának meghatározása
    const getCardStyle = (id, pairId) => {
      if (selectedCards.some((card) => card.id === id) || matchedPairs.includes(pairId)) {
        return { opacity: 0.5, cursor: 'not-allowed', width: '150px', height: '150px'};
      }
      return { cursor: 'pointer', width: '150px', height: '150px'};
    };

    const closePopup = () => {
      //setIsOpen(false);
      setSelectedCards([]);
      setMatchedPairs([]);
      setIsDisabled(false);

    };


      
      return (
        <div className="container mt-4">
              <h1 className="text-center mb-4">Párosító Játék</h1>
              <table>
                <tr>
                  <td>
                      {/* Bal oldali oszlop */}
                      <div className="col-md-6">
                        {imagePairs.slice(0, 4).map((image) => (
                          <Card
                            key={image.id}
                            className="mb-3"
                            onClick={() => handleCardClick(image.id, image.pairId)}
                            style={getCardStyle(image.id, image.pairId)}
                          >
                            <Card.Img variant="top" src={image.src} />
                          </Card>
                        ))}
                      </div>
                  </td>
                  <td>
                    {/* Jobb oldali oszlop */}
                    <div className="col-md-6">
                      {imagePairs.slice(4, 8).map((image) => (
                        <Card
                          key={image.id}
                          className="mb-3"
                          onClick={() => handleCardClick(image.id, image.pairId)}
                          style={getCardStyle(image.id, image.pairId)}
                        >
                          <Card.Img variant="top" src={image.src} />
                        </Card>
                      ))}
                    </div>
                  </td>
                </tr>
              </table>
              {matchedPairs.length === 4 && (
                <dialog open={isOpen} onOpenChange={setIsOpen}className="text-center mt-4">
                <dialogContent>
                  <dialogHeader>
                    <dialogTitle>Gratulálunk!</dialogTitle>
                  </dialogHeader>
                  <div className="text-center text-lg">Minden párt megtaláltál!</div>
                  <div className="flex justify-center mt-4">
                    <button onClick={closePopup}>OK</button>
                  </div>
                </dialogContent>
              </dialog>
              )}
        </div>
      );
}

export default Puzzle;